<style lang="less">
    .page_con.read{
        width:100vw;
        height:100vh;
        overflow: hidden;
        background:url("../assets/images/bg3.png") no-repeat;
        background-size: 100% 100%;
        .top_con{
            width:100%;
            height:11vh;
            padding:0 5vw;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            background:url("../assets/images/topbar-1.png") no-repeat;
            background-size: 100% 100%;
            img{
                width:.6rem;
                height:auto;
                display: block;
            }
            p{
                font-size: .4rem;
                color:#fff;
                font-weight: bold;
                margin-left:.1rem;
                letter-spacing: .05rem;
            }
        }
        .content_con{
            width:100%;
            height:79vh;
            // display: flex;
            // align-items: center;
            // justify-content: center;
            .up_con{
                width:100%;
                height:54vh;
                display: flex;
                align-items: center;
                justify-content: center;
                .quest_num{
                    width:30vw;
                    height:auto;
                    overflow: hidden;
                    position: absolute;
                    top:13vh;
                    left:5vw;
                    z-index: 11;
                    img{
                        width:100%;
                        height:auto;
                        display: block;
                    }
                    p{
                        width: 100%;
                        text-align: center;
                        color:#fff;
                        font-size: .3rem;
                        position: absolute;
                        left:50%;
                        top:47%;
                        z-index: 11;
                        transform: translate(-50%,-50%);
                    }
                }
                .quest_row{
                    width:100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    .item_text{
                        width:30vw;
                        height:30vw;
                        line-height:30vw;
                        text-align: center;
                        background:#FCD688;
                        border-radius: .1rem;
                        font-size: 20vw;
                        font-weight: bold;
                        color:#333;
                        
                    }
                    .item_text:first-child{
                        margin-right:3vw;
                    }
                    .item_text.active{
                        color:#e7211a;
                    }
                }
                .quest_row:first-child{
                    margin-bottom:3vw;
                }
            }
            .down_con{
                width:100%;
                height:35vh;
                background:#FCD688;
                padding:2vh 5vw;
                p{
                    width: 100%;
                    text-align: center;
                    font-size: .5rem;
                    font-weight: bold;
                    letter-spacing: .02rem;
                    margin-bottom: 5vh;
                }
                .answers{
                    width:100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    >div{
                        width:20vw;
                        height:20vw;
                        line-height:20vw;
                        text-align: center;
                        font-size: 1rem;
                        font-weight: bold;
                        background:#fff;
                        border-radius: .1rem;
                        margin-right: 1vw;
                        box-shadow: 0 0 .05rem 0 inset #666;

                    }
                    >div:last-child{
                        margin-right:0;
                    }
                }
            }
        }
        .btns{
            width:100%;
            height:10vh;
            // position: fixed;
            bottom: 0;
            left: 0;
            z-index: 11;
            padding:0 5vw;
            display: flex;
            align-items: center;
            justify-content: space-between;
            img{
                width:25vw;
                height:auto;
                display: block;
            }
        }
    }
</style>
<template>
    <div class="page_con read">
        <div class="top_con">
            <img src="../assets/images/time.png" alt="">
            <interval :time="time" ref="time"></interval>
        </div>
        <div class="content_con">
            <div class="up_con">
                <!-- <div class="quest_num">
                    <img src="../assets/images/grade-button.png" alt="">
                    <p>第112題</p>
                </div> -->
                <div class="questions">
                    <div class="quest_row" v-for="(item,index) in data.questions" :key="index">
                        <div v-for="(i,idx) in item.text" :class="['item_text',i==item.active?'active':'']" :key="idx">{{i}}</div>
                    </div>
                </div>
            </div>
            <div class="down_con">
                <p class="title">請選出紅色字正確讀音</p>
                <div class="answers">
                    <div class="answer_item" v-for="(item,index) in data.opts" :key="index" @click="choice(item)">{{item.text}}</div>
                </div>
            </div>
        </div>
        <div class="btns">
            <img src="../assets/images/back-button.png" @click="$router.go(-1)" alt="">
            <img src="../assets/images/tip-button.png" @click="openTip" alt="">
        </div>

        <div class="shade" v-if="tips_bag || toast != 'none'">
            <div class="tips_bag" v-if="tips_bag">
                <img src="../assets/images/tip-bg.png" alt="">
                <img class="close" src="../assets/images/close-tipbutton.png" alt="" @click="tips_bag='close'">
                <p v-if="data.tips" v-html="data.tips || '今天沒有學習錦囊'"></p>
                <p v-else style="text-align:center;" v-html="'今天沒有學習錦囊'"></p>
            </div>
            <div class="toast" v-if="toast != 'none'">
                <div v-if="toast == 'success'" class="toast_success">
                    <template v-if="isEnd">
                        <img class="result" src="../assets/images/DONE-answer.png" alt="">
                        <img src="../assets/images/backhome.png" alt="" class="goon" @click="answerEnd">
                    </template>
                    <template v-else>
                        <img class="result" src="../assets/images/yes-answer.png" alt="">
                        <img src="../assets/images/next.png" alt="" class="goon" @click="next">
                    </template>
                </div>
                <div v-if="toast == 'error'" class="toast_error">
                    <img class="result" src="../assets/images/NO-answer.png" alt="">
                    <img src="../assets/images/continue.png" alt="" class="goon" @click="reset">
                </div>
            </div>
        </div>
        <div class="shade tips_result" v-if="tips_bag == 'close'">
            <div class="tips_result">
                <img class="readed" src="../assets/images/read-done.png" alt="">
                <img class="close" @click="tips_bag=false" src="../assets/images/certain-button.png" alt="">
            </div>
        </div>
    </div>
</template>
<script>
import interval from './timer';
export default {
    components:{
        interval
    },
    data(){
        return {
            pauseStatus:false,  //暫停狀態
            time:300,    //倒計時
            
            //多套题记录
            setsIndex:0,        //当前第几套题
            
            tips_bag:false,
            toast:'none',
            isEnd:false,        //是否结束
            right_temp:1,        //小題
            is_right:1,         //是否全對

            tips_time:0,

            data:{
                questions:[],
                tips:'',
                opts:[
                    // {
                    //     text:'問',
                    //     id:'1',
                    // },
                ],
            }
        }
    },
    mounted() {
        let query = this.$route.query;
        this.getData(query.date);
    },
    methods:{
        answerEnd(){
            this.updateData(this.getTime(),this.tips_time,this.is_right,this.$route.query.date);
        //     let vm = this;
        //     this.$http.get('/GameDaily/push?rest_key=1',{params:{SrtTime:this.getTime(),tips:this.tips_time,result:this.is_right}}).then(res=>{
        //         console.log(res);
        //         if(res.data == 'Done'){
        //             this.$router.push('/index');
        //         }
        //     })
        },
        getTime(){
            return this.time - this.$refs.time.getTime();
        },
        reset(){
            this.toast='none';
        },
        hasMore(){
            let setsIndex = this.setsIndex + 1;
            if(this.$store.getters.gameData[setsIndex]){
                return true;
            }else{
                return false;
            }
        },
        next(){
            let setsIndex = this.setsIndex;
            setsIndex+=1;
            // if(!this.right_temp){
            //     this.is_right = 0;
            // }
            // if(setsIndex == this.$store.getters.gameData.length){    //所有套题答完
            if(this.hasMore()){    //所有套题答完
                this.setsIndex = setsIndex;
                this.init(this.setsIndex);
                this.toast = 'none';
            }else{
                this.isEnd = true;
            }
        },
        choice(item){
            this.right_temp = item.right;
            // this.next();
            if(this.hasMore()){
                this.isEnd = false;
            }else{
                this.isEnd = true;
            }
            this.toast = this.right_temp?'success':'error';
        },
        openTip(){
            this.tips_bag = true;
            this.tips_time++;
        },
        getData(date){
            let vm = this;
            vm.$http.get('/GameDaily/index?type=7&rest_key=1'+(date?('&pushdate='+date):'')).then(res=>{
                console.log(res);
                if(res.data.code == 1){
                    vm.$store.commit('setGameData',res.data.data.game);
                    vm.init(vm.setsIndex);
                }
            })
        },
        init(sets){
            let data = JSON.parse(JSON.stringify(this.$store.getters.gameData[sets]));
            this.data.questions = data.word.map(v=>{
                return {text:v[0].split(''),active:v[1]}
            });
            console.log(this.data.questions);
            this.data.tips = data.tips.replace('<rn>','<br><br>');
            this.data.opts = this.randomIndex(data.options.map((v,i)=>{
                return {
                    text:v,
                    id:i,
                    right:i==0?1:0,
                }
            }));
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/read.vue